import styled, { css } from 'styled-components';
import { Link, Text } from '@sparknz/spark-pattern-library';

export const InStockPill = styled(Text)`
  ${({ theme: { palette, borderRadius, spacing } }) => css`
    background-color: ${palette.baseColors.sparkGreen};
    color: ${palette.baseColors.wairua};
    padding: ${spacing.s0_5} ${spacing.s2};
    border-radius: ${borderRadius.r2};
    text-align: center;
    width: 82px;
  `}
`;

export const OutStockPill = styled(Text)`
  ${({ theme: { palette, borderRadius, spacing } }) => css`
    background-color: ${palette.baseColors.moeraki};
    color: ${palette.baseColors.wairua};
    padding: ${spacing.s0_5} ${spacing.s2};
    border-radius: ${borderRadius.r2};
    text-align: center;
    width: 112px;
  `}
`;

export const Subtitle = styled(Text)`
  color: ${({ theme: { palette } }) => `${palette.baseColors.mawheranui}`};
`;

export const PhoneLink = styled(Link)`
  text-decoration: none;
`;

export const AvailabilityText = styled(Text)`
  color: ${({ theme: { palette } }) => `${palette.baseColors.mawhero}`};
`;
